import './SaveButton.css'
import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import DefaultButton from '../DefaultButton/DefaultButton'

interface IProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [x: string]: any;
  title?: string
}

const SaveButton = ({ title, children, ...otherProps }: IProps) => {
  return (
    <DefaultButton title={title ? title : 'Save Changes'} className='btn-lg btnWidth' variant='primary' {...otherProps}>
      <FontAwesomeIcon icon={['far', 'save']} />&nbsp;
      {children ? children : <span>Save</span>}
    </DefaultButton>
  )
}

export default SaveButton
